/**
 * Version information utilities
 * Displays app version, build number, and environment
 */

import packageJson from '../../package.json';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

/**
 * Get web app version from package.json
 */
export const getWebVersion = () => {
  return packageJson.version || '0.1.0';
};

/**
 * Get native app version and build number
 * Returns Promise with { version, buildNumber }
 */
export const getNativeAppInfo = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      const info = await App.getInfo();
      return {
        version: info.version,
        buildNumber: info.build,
        platform: Capacitor.getPlatform()
      };
    } catch (error) {
      console.error('Error getting native app info:', error);
      return { version: 'Unknown', buildNumber: 'Unknown', platform: Capacitor.getPlatform() };
    }
  }
  return null;
};

/**
 * Get environment name
 */
export const getEnvironment = () => {
  const apiUrl = process.env.REACT_APP_CPAP_API || '';

  if (apiUrl.includes('cribsydemo')) {
    return 'Staging';
  } else if (apiUrl.includes('cribsy-api') || apiUrl.includes('herokuapp.com/cribsy')) {
    return 'Production';
  } else if (apiUrl.includes('localhost')) {
    return 'Development';
  }

  return 'Unknown';
};

/**
 * Get formatted version string
 * Examples:
 *  - Web: "v0.1.0 (Staging)"
 *  - Native: "v1.2.2 (16) - Staging - Android"
 */
export const getVersionString = async () => {
  const env = getEnvironment();

  if (Capacitor.isNativePlatform()) {
    const appInfo = await getNativeAppInfo();
    if (appInfo) {
      return `v${appInfo.version} (${appInfo.buildNumber}) - ${env} - ${appInfo.platform}`;
    }
  }

  const webVersion = getWebVersion();
  return `v${webVersion} - ${env} - Web`;
};
